import html from "./tech-imgs/html.png";
import css from "./tech-imgs/css.jfif";
import js from "./tech-imgs/js.png";
import nodeJs from "./tech-imgs/nodejs.png";
import mongoDB from "./tech-imgs/mongodb.png";
import react from "./tech-imgs/react.png";
import reactNative from "./tech-imgs/react-native.png";
import express from "./tech-imgs/express.png";
import jest from "./tech-imgs/jest.png";
import photoshop from "./tech-imgs/photoshop.png";
import adobeIllistrator from "./tech-imgs/adobe-illstrator.png";
import figma from "./tech-imgs/figma.png";
import balsamiq from "./tech-imgs/balsamiq.jfif";
import agile from "./tech-imgs/agile.png";
import lean from "./tech-imgs/lean.png";
import tdd from "./tech-imgs/tdd.png";
import npm from "./tech-imgs/npm.png";
import postman from "./tech-imgs/postman.png";
import devTools from "./tech-imgs/dev-tools.jfif";
import git from "./tech-imgs/git.png";
import github from "./tech-imgs/github.png";
import trello from "./tech-imgs/trello.jfif";
import slack from "./tech-imgs/slack.jpg";

export default [
  // TS
  // PY
  { name: "HTML", img_src: html },
  { name: "CSS", img_src: css },
  { name: "JavaScript", img_src: js },
  { name: "Node JS", img_src: nodeJs },
  { name: "Mongo DB", img_src: mongoDB },
  { name: "React", img_src: react },
  { name: "React Native", img_src: reactNative },
  { name: "Express", img_src: express },
  { name: "Jest", img_src: jest },
  // { name: "photoshop", img_src: photoshop },
  // { name: "adobeIllistrator", img_src: adobeIllistrator },
  // { name: "figma", img_src: figma },
  // { name: "balsamiq", img_src: balsamiq },
  // { name: "agile", img_src: agile },
  // { name: "lean", img_src: lean },
  // { name: "tdd", img_src: tdd },
  { name: "NPM", img_src: npm },
  // { name: "postman", img_src: postman },
  // { name: "devTools", img_src: devTools },
  { name: "Git", img_src: git },
  // { name: "github", img_src: github },
  // { name: "trello", img_src: trello },
  // { name: "slack", img_src: slack },
];
